// Extracts a friendly error message from a round-creation / update
// response. Handles three shapes the backend can return:
//
//   1. `non_field_errors`: ["..."]  — generic validation errors
//   2. `detail`: "..."              — DRF default error envelope
//   3. field-level errors           — { start_date: ["can not be less than now 2026-..."], ... }
//
// For field-level errors the field name is humanized
// ("start_date" → "Start date") and the message is cleaned up
// ("can not" → "cannot", trailing ISO-ish timestamps stripped) so
// the dialog reads naturally:
//
//   { "start_date": ["can not be less than now 2026-06-10 14:55:00-07:00"] }
//     →  "Start date cannot be less than now"
//
// Returns null when no usable message is found so the caller can
// fall back to its own generic copy.
export function extractRoundErrorMessage(err) {
  const body = err && err.response && err.response.body;
  if (!body) return null;

  if (typeof body === "string") return body;

  if (Array.isArray(body.non_field_errors) && body.non_field_errors.length > 0) {
    return cleanMessage(body.non_field_errors[0]);
  }

  if (body.detail) return cleanMessage(String(body.detail));

  for (const key of Object.keys(body)) {
    const val = body[key];
    const raw = Array.isArray(val)
      ? val[0]
      : (typeof val === "string" ? val : null);
    if (!raw) continue;

    const label = humanizeFieldName(key);
    const cleaned = cleanMessage(String(raw));
    return label ? `${label} ${cleaned}` : cleaned;
  }

  return null;
}

function humanizeFieldName(key) {
  if (!key) return "";
  const spaced = key.replace(/_/g, " ").trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

function cleanMessage(msg) {
  if (!msg) return "";
  return String(msg)
    // "can not" → "cannot"
    .replace(/\bcan not\b/gi, "cannot")
    // Strip a trailing ISO-ish timestamp (with optional timezone).
    // Matches: "2026-06-10", "2026-06-10 14:55", "2026-06-10 14:55:00",
    // "2026-06-10T14:55:00-07:00", "2026-06-10 14:55:00-0700", etc.
    .replace(
      /\s+\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2})?(?:[+-]\d{2}:?\d{2})?)?\s*\.?$/,
      ""
    )
    .trim();
}



// WEBPACK FOOTER //
// ./src/instructor/utils/round-error.js